export default __webpack_public_path__ + "static/media/Banner_image_Philosophers_stone.438cf575.jpg";